// use preferably of domain: 'src/business/shared/domain/order'
export enum OrderDeliveryMethodType {
  DELIVERY = 'delivery',
  MARKETPLACE = 'marketplace',
  PICKUP = 'pickup',
}
